import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <p>Contact & promos: contact@johannarty.com</p>
      <p><a target="_blank" href="https://drive.google.com/drive/folders/1QeCp--YyRB0gBrIKl2jpFSPCXCUAxh8e" rel="noopener noreferrer">Get presskit</a></p>
    </footer>
  );
}

export default Footer